import { createSelector } from "reselect";

const ordersSelector = (state) => state.orders;

export const getBookTitle = createSelector(
    [ordersSelector],
    state => state.bookTitle
)

export const getAuthor = createSelector(
    [ordersSelector],
    state => state.author
)

export const getBookCover = createSelector(
    [ordersSelector],
    state => state.bookCover
)

export const getPurchaser = createSelector(
    [ordersSelector],
    state => state.purchaser
)

export const getPurchaserFurigana = createSelector(
    [ordersSelector],
    state => state.furigana
)

export const getEmail = createSelector(
    [ordersSelector],
    state => state.email
)

export const getNoteUrl = createSelector(
    [ordersSelector],
    state => state.noteUrl
)

export const getIdentification = createSelector(
    [ordersSelector],
    state => state.identification
)

export const getCopyright = createSelector(
    [ordersSelector],
    state => state.copyright
)

export const getBirthOfDay = createSelector(
    [ordersSelector],
    state => state.birthOfDay
)

export const getSex = createSelector(
    [ordersSelector],
    state => state.sex
)

export const getHowDidChermoKnow = createSelector(
    [ordersSelector],
    state => state.howDidChermoKnow
)

export const getOtherSpecificContent = createSelector(
    [ordersSelector],
    state => state.otherSpecificContent
)